<template>
	<div>
		<div class="upper_div"></div>
		<div class="bgImg notFoundSection">
			<div class="titleContainer">
				<h1 class="title">המיקום לא נמצא</h1>
				<p class="plainText">כתובת העמוד לא נמצאה… נסו לנווט שוב לאיזור אחר</p>
			</div>
			<div class="btnContainer">
				<button @click="$parent.showContact()" class="btn big white" type="button">צור קשר</button>
				<button @click="goToHomePage()" class="btn big blue" type="button">
					חזור לדף הבית
				</button>
			</div>
			<img class="img404" src="/images/404.png" alt="" />
		</div>
	</div>
</template>

<script>
	export default {
		name: "NotFound",
		data() {
			return {};
		},
		methods: {
			goToHomePage() {
				this.$router.push({ name: "home" });
			},
		},
	};
</script>

<style>
	.centered {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
</style>
